<template>
  <div class="firstpage">
    <img class="image-kv" v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/pc/kv.jpg'" alt="" />
    <img class="image-kv" v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/mob/kv.jpg'" alt="" />

    <img class="image-2" v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/pc/2.jpg'" alt="" />
    <img class="image-2" v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/mob/2.jpg'" alt="" />

    <img class="image-3" v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/pc/3.jpg'" alt="" />
    <img class="image-3" v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/mob/3.jpg'" alt="" />

    <img class="image-4" v-if="!isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/pc/4.jpg'" alt="" />
    <img class="image-4" v-if="isPortrait" :src="preText + '/assets/~/media/images/activity/202604suchao/mob/4.jpg'" alt="" />

    <div class="button-container">
      <div
        class="button-item-wrapper"
        v-for="item in buttonUrls"
        :key="item.index"
        @mouseenter="hoveredButtonIndex = item.index"
        @mouseleave="hoveredButtonIndex = null"
        @click="handleButtonClick(item)"
      >
        <img
          class="button-item"
          :src="preText + (isPortrait ? item.darkMob : (hoveredButtonIndex === item.index ? item.lightPc : item.darkPc))"
          :alt="item.name"
        />
        <img
          v-show="!isPortrait && hoveredButtonIndex === item.index && item.qrcodePc"
          class="qrcode-popup"
          :src="preText + item.qrcodePc"
          :alt="item.name + '二维码'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      preText:'https://www.kia.cn',
      hoveredButtonIndex: null,
      buttonUrls: [
        {
          index: 1,
          name: '公众号',
          darkPc: '/assets/~/media/images/activity/202604suchao/pc/icon1a.png',
          lightPc: '/assets/~/media/images/activity/202604suchao/pc/icon2a.png',
          darkMob: '/assets/~/media/images/activity/202604suchao/pc/icon1a.png',
          qrcodePc: '/assets/~/media/images/activity/202604suchao/pc/qrcode_a.png',
          link: 'https://mp.weixin.qq.com/s/eskVL8TZ19Ohtv0EByJfbw',
        },
        // {
        //   index: 2,
        //   name: '小红书',
        //   darkPc: '/assets/~/media/images/activity/202604suchao/pc/icon1c.png',
        //   lightPc: '/assets/~/media/images/activity/202604suchao/pc/icon2c.png',
        //   darkMob: '/assets/~/media/images/activity/202604suchao/pc/icon1c.png',
        //   qrcodePc: '/assets/~/media/images/activity/202604suchao/pc/qrcode_c.png',
        //   link: 'http://xhslink.com/o/4du6rbk7luN',
        // },
        {
          index: 3,
          name: '微博',
          darkPc: '/assets/~/media/images/activity/202604suchao/pc/icon1d.png',
          lightPc: '/assets/~/media/images/activity/202604suchao/pc/icon2d.png',
          darkMob: '/assets/~/media/images/activity/202604suchao/pc/icon1d.png',
          link: 'https://weibo.com/1348898682/5329369590405698',
        },
      ],
    };
  },
  components: {  },
  mounted: function () {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    }else{
      this.preText = 'https://www.kia.cn'
    }
    if (getUrlKey("minip")) {
      this.minip = true;
    }
    new Swiper(".mySwiper-kv", {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: ".swiper-pagination-kv",
        clickable: true,
      },
      navigation: {
        nextEl: "#swiper-button-next-kv",
        prevEl: "#swiper-button-prev-kv",
      },
      on: {
        slideChangeTransitionEnd: this.slideChangeTransitionEnd,
      },
    });
  },
  methods: {
    handleButtonClick(item) {
      if (!item) return;
      if (!this.isPortrait) {
        if (item.name === '微博' && item.link) {
          window.open(item.link, '_blank');
        }
        return;
      }
      if (item.link) {
        window.open(item.link, '_blank');
      }
    },
    custormAnchor(anchorName) {
      // 黑色按钮：滚动到四屏 scroll_title 区域
      if (anchorName === 'scrollTitle') {
        const scrollFn = this.$parent && this.$parent.scrollToScrollTitle;
        if (typeof scrollFn === "function") {
          scrollFn();
        }
        return;
      }
      // 其他锚点：走原有滚动逻辑
      const scrollFn = this.$parent && this.$parent.scrollAwSection;
      if (typeof scrollFn === "function") {
        scrollFn(anchorName);
      }
    },
    clickPlayIcon: function () {
      let swiperIndex = this.$refs.kiaSwiper.swiper.activeIndex;
      let dom;
      switch (swiperIndex) {
        case 0:
          dom = document.querySelector(".thirdpage");
          dom.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          break;
        case 1:
          dom = document.querySelector(".fourpage");
          dom.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";
.firstpage {
  background-color: rgba(166, 172, 176, 1);
  position: relative;
  // height: calc(1080 / 1920 * 100vw);
  width: 100%;
  user-select: none;
  z-index: 0;
    @media (max-width: 767px) {
    // height: calc(1915 / 1125 * 100vw) !important;
    }
    img{
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
    @media (max-width: 767px) {
      img {
        margin-top: -1px;
      }
      .image-kv { 
        height: calc(2422 / 1500 * 100vw);
      }
      .image-2 {
        height: calc(2792 / 1500 * 100vw);
      }
      .image-3 {
        height: calc(3470 / 1500 * 100vw);
      }
      .image-4 {
        height: calc(2342 / 1500 * 100vw);
      }
      .button-container {
        position: absolute;
        bottom: calc(394 / 750 * 100vw);
        left: calc(101.5 / 750 * 100vw);
        display: flex;
        align-items: center;
        gap: calc(10 / 750 * 100vw);
      }
      .button-item-wrapper {
        position: relative;
        cursor: pointer;
      }
      .button-item {
        width: calc(108 / 750 * 100vw);
        height: calc(54 / 750 * 100vw);
        object-fit: contain;
      }
      .qrcode-popup {
        display: none;
      }
      .image-btn {
        position: absolute;
        display: none;
      }
    }
    @media (min-width: 767px) {
      .image-kv { 
        height: calc(1080 / 1920 * 100vw);
      }
      .image-2 {
        height: calc(1054 / 1920 * 100vw);
      }
      .image-3 {
        height: calc(947 / 1920 * 100vw);
      }
      .image-4 {
        height: calc(861 / 1920 * 100vw);
      }
      .button-container {
        position: absolute;
        bottom: calc(350 / 1920 * 100vw);
        left: calc(1212 / 1920 * 100vw);
        display: flex;
        align-items: center;
        gap: calc(8 / 1920 * 100vw);
      }
      .button-item-wrapper {
        position: relative;
        cursor: pointer;
      }
      .button-item {
        width: calc(108 / 1920 * 100vw);
        height: calc(48 / 1920 * 100vw);
        object-fit: contain;
      }
      .qrcode-popup {
        position: absolute;
        // left: 50%;
        // bottom: calc(82 / 1920 * 100vw);
        // transform: translateX(-50%);
        top: calc(60 / 1920 * 100vw);
        left: 50%;
        transform: translateX(-50%);
        width: calc(183 / 1920 * 100vw);
        height: calc(192 / 1920 * 100vw);
        min-width: calc(183 / 1920 * 100vw);
        min-height: calc(192 / 1920 * 100vw);
        object-fit: contain;
        z-index: 5;
      }
      .image-btn {
        display: none;
      }
    }
  // }
  .icons {
    .playicon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      background: url("../../assets/images/play.png") no-repeat;
      z-index: 10;
      cursor: pointer;
    }
  }
  .txt-container {
    width: 21%;
    position: absolute;
    left: 12%;
    top: 13%;
    // .btn-container {
    //   display: flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   margin-top: 8%;
    //   a {
    //     width: 48%;
    //   }
    // }
  }
  .city {
    width: 20%;
    position: absolute;
    bottom: 15vh;
    left: 12%;
  }
  .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      color: #fff;
    }
  ::v-deep .swiper-pagination-bullet {
    width: 40px;
    height: 2px;
    display: inline-block;
    border-radius: 0;
    background: #fff;
    color: #fff;
    opacity: 1;
  }
  ::v-deep .swiper-pagination-bullet-active{
    background: #000;
  }
  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 40px;
    left: 30px;
    width: 100%;
    position: absolute;
    color: #fff;
    z-index: 1;
}
  @media screen and (orientation: portrait) {
    position: relative;
    // height: calc(1216 / 750 * 100vw);
    width: 100%;
    user-select: none
      no-repeat;
    .txt-container {
      // margin-top: 5%;
      position: absolute;
      top: 7%;
      left: 50%;
      transform: translateX(-50%);
      width: 70%;
    //   .btn-container {
    //     display: flex;
    //     justify-content: space-between;
    //     width: 100%;
    //     margin-top: 5%;
    //   }
    }
    .city {
        width: 45%;
        position: absolute;
        bottom: 16vh;
        left: 50%;
        transform: translateX(-50%);
    }
    ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: 15vh;
    }
  }
}
@media (min-width: 767px) {
  .kv-black-button {
    position: absolute;
    top: calc(334 / 1920 * 100vw);
    left: calc(155 / 1920 * 100vw);
    width: calc(185 / 1920 * 100vw) !important;
    height: calc(52 / 1920 * 100vw) !important;
    cursor: pointer;
  }
  .kv-transparent-button {
    position: absolute;
    top: calc(334 / 1920 * 100vw);
    left: calc(352 / 1920 * 100vw);
    width: calc(185 / 1920 * 100vw) !important;
    height: calc(52 / 1920 * 100vw) !important;
    cursor: pointer;
  }
}
@media (max-width: 767px) {
  .kv-black-button {
    position: absolute;
    top: calc(355 / 750 * 100vw);
    left: calc(60 / 750 * 100vw);
    width: calc(222 / 750 * 100vw) !important;
    height: calc(62.4 / 750 * 100vw) !important;
  }
  .kv-transparent-button {
    position: absolute;
    top: calc(355 / 750 * 100vw);
    left: calc(296 / 750 * 100vw);
    width: calc(222 / 750 * 100vw) !important;
    height: calc(62.4 / 750 * 100vw) !important;
  }
}
</style>
